var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c(_setup.CommonHeader),_c('router-view'),_c(_setup.CommonFooter),_c(_setup.BackTop),_c(_setup.LeaveMessage)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }